module.exports = __webpack_public_path__ + "static/media/exist-educate-text.0b10a81a.png";